const initState = {
    privacyPolicy: undefined,
    returnsPolicy: undefined,
    cookiesPolicy: undefined,
    checkoutPolicy: undefined,
};

export const SET_PRIVACY_POLICY = 'SET_PRIVACY_POLICY';
export const SET_COOKIES_POLICY = 'SET_COOKIES_POLICY';
export const SET_RETURNS_POLICY = 'SET_RETURNS_POLICY';
export const SET_CHECKOUT_POLICY = 'SET_CHECKOUT_POLICY';

export const setPrivacyPolicy = (data) => ({ type: SET_PRIVACY_POLICY, payload: data });
export const setReturnsPolicy = (data) => ({ type: SET_RETURNS_POLICY, payload: data });
export const setCookiesPolicy = (data) => ({ type: SET_COOKIES_POLICY, payload: data });
export const setCheckoutPolicy = (data) => ({ type: SET_CHECKOUT_POLICY, payload: data });

export default (state = initState, action) => {
    switch (action.type) {
        case SET_PRIVACY_POLICY:
            return { ...state, privacyPolicy: action.payload };
        case SET_RETURNS_POLICY:
            return { ...state, returnsPolicy: action.payload };
        case SET_COOKIES_POLICY:
            return { ...state, cookiesPolicy: action.payload };
        case SET_CHECKOUT_POLICY:
            return { ...state, checkoutPolicy: action.payload };
        default:
            return state;
    }
};
